import { render, staticRenderFns } from "./DayPriceTab.vue?vue&type=template&id=0620a852&scoped=true"
import script from "./DayPriceTab.vue?vue&type=script&lang=js"
export * from "./DayPriceTab.vue?vue&type=script&lang=js"
import style0 from "./DayPriceTab.vue?vue&type=style&index=0&id=0620a852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0620a852",
  null
  
)

export default component.exports